<template>
    <div class="py-3 w-100 scrollable">
        <b-card bg-variant="light" class="col-4 mx-auto mb-3">
            <h4>{{ $t('menu.login') }}</h4>
            <hr />
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-form v-if="currentStep === 1" @submit.prevent="checkLogin">
                <b-form-group :label="$t('person.login')">
                    <b-form-input type="text" v-model.trim="username" :disabled="isDisabled" required>
                    </b-form-input>
                </b-form-group>
                <b-form-row class="justify-content-end mx-0">
                    <b-btn variant="primary" class="ml-auto" type="submit" :disabled="isDisabled">
                        {{ $t('general.next') }}
                    </b-btn>
                </b-form-row>
            </b-form>
            <b-form v-if="currentStep === 2" @submit.prevent="checkPassword">
                <b-form-group :label="$t('person.password')">
                    <b-form-input type="password" v-model="password" :disabled="isDisabled" required>
                    </b-form-input>
                </b-form-group>
                <b-form-row class="mr-0">
                    <a href="#" variant="link" @click.prevent="goToStep(currentStep - 1)">
                        <back-icon title="" />&nbsp;{{ $t('general.back') }}
                    </a>
                    <b-btn variant="primary" class="ml-auto" type="submit" :disabled="isDisabled">
                        {{ $t('general.next') }}
                    </b-btn>
                </b-form-row>
            </b-form>
            <b-form v-if="currentStep === 3" @submit.prevent="checkSms">
                <b-alert variant="info" show>
                    {{ $t('general.smsCodeSended', [phoneNumber]) }}
                </b-alert>
                <b-form-group :label="$t('general.smsCode')">
                    <b-form-input type="text" v-model.trim="smsCode" :disabled="isDisabled">
                    </b-form-input>
                </b-form-group>
                <b-form-group v-if="iin !== '' && haveNcaCert" :label="$t('general.iin')">
                    <b-form-input type="text" v-model.trim="iin" disabled>
                    </b-form-input>
                </b-form-group>
                <b-form-group>
                    <b-form-checkbox v-model="haveNcaCert">{{ $t('general.haveNcaCert') }}</b-form-checkbox>
                </b-form-group>
                <b-form-row class="mr-0">
                    <a href="#" variant="link" @click.prevent="goToStep(currentStep - 1)">
                        <back-icon title="" />&nbsp;{{ $t('general.back') }}
                    </a>
                    <b-btn variant="primary" class="ml-auto" type="submit" :disabled="isDisabled">
                        {{ $t('general.next') }}
                    </b-btn>
                </b-form-row>
            </b-form>
            <div v-if="currentStep === 4">
                <authenticated :downloadUrl="certUrl" :certificateName="certificateName"></authenticated>
                <div class="row justify-content-end mx-0">
                    <b-button variant="primary" @click="goToStep(1)">{{ $t('general.next') }}</b-button>
                </div>
            </div>
        </b-card>
        <keyboard v-model="username" v-show="currentStep === 1"
            :layouts="kbLayouts">
        </keyboard>
        <keyboard v-model="password" v-show="currentStep === 2"
            :layouts="kbLayouts">
        </keyboard>
    </div>
</template>

<script>
/* eslint-disable */
import Authenticated from '@/components/Authenticated.vue'
import keyboard from 'vue-keyboard'

export default {
    name: 'login',
    components: { keyboard, Authenticated },
    data () {
        return {
            alert: String,
            showAlert: false,
            kbLayouts: [
                '1234567890-={Delete:backspace}|qwertyuiop[]\\|asdfghjkl;\'|{Shift:goto:1}zxcvbnm,./|{Space:space}',
                '!@#$%^&*()_+{Delete:backspace}|QWERTYUIOP{{}}|||ASDFGHJKL:"|{Shift:goto:0}ZXCVBNM<>?|{Space:space}'
            ],
            username: '',
            certificateName: '',
            password: '',
            smsCode: '',
            phoneNumber: '',
            iin: '',
            authType: null,
            currentStep: 1,
            reCaptchaKey: this.$appConfig.reCaptchaSiteKey,
            certUrl: '',
            haveNcaCert: false
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        prepare: function () {
            this.showAlert = false
            this.alert = ''
        },
        checkLogin: function (token) {
            this.$request.getAuthType(this, this.username, token, result => {
                this.authType = result
                this.goToStep(2)
                this.password = ''
            }, this.displayAlert)
        },
        checkPassword: function (token) {
            if (this.authType === this.$appConfig.authType.pass.name) {
                this.$request.getSms(this, this.username, this.password, token,
                    result => {
                        this.phoneNumber = result.value.phoneNumber
                        this.iin = result.value.iin
                        this.goToStep(3)
                    }, this.displayAlert)
            } else {
                this.certLogin()
            }
        },
        checkSms: function (token) {
            if (this.haveNcaCert) {
                this.$request.checkSmsNca(this, this.username, this.password, this.smsCode, token,
                    result => {
                        this.goToStep(1)
                    }, this.displayAlert)
            } else {
                this.$request.checkSms(this, this.username, this.password, this.smsCode, token,
                    result => {
                        this.certUrl = result.value
                        this.goToStep(4)
                        this.certificateName = this.username
                        this.username = ''
                        this.password = ''
                    }, this.displayAlert)
            }
        },
        certLogin: function () {
            this.prepare();
            var roles = this.$appConfig.role;
            
            const onError = error => {
                this.displayAlert(error);
                this.$ncalayer.breakSession(null);
            };

            const getUserInfoSuccess = async (result, token) => {
                if (result.length === 0) {
                    onError('cantGetUserInfo');
                    return;
                }

                const userData = result[0];
                userData.token = token;

                this.$store.commit('setUserInfo', userData);
                
                this.$request.getTaxOrgs(this);
                
                const userRole = userData.role.toString();
                
                switch (userData.role.toString()) {
                    case roles.inspector:
                        this.$router.push('/dealers');
                        break;

                    case roles.admin:
                        this.$router.push('/persons');
                        break;

                    case roles.operator:
                        this.$router.push('/dealers');
                        break;

                    case roles.dealer:
                        this.$router.push('/kkms');
                        break;

                    default:
                        this.$router.push('/profile');
                }

                if (userRole === roles.dealer) {
                    try {
                        const response = await this.$request.sendRequestAsync(this, this.$appConfig.apiUrls.dealer.getAll);

                        this.$store.commit('setTaxpayer', response[0] || {});
                        
                    } catch(error) {
                        console.error(error);

                        this.$router.push({ name: 'error', params: { code: 'cantGetDealerInfo' } })
                    }   
                }
            };

            const tokenSuccess = token => {
                this.$request.getUserInfo(
                    this, 
                    this.username, 
                    token, 
                    response => getUserInfoSuccess(response, token), 
                    onError);
            };            

            this.$request.getToken(
                this, 
                this.username, 
                this.password, 
                tokenSuccess, 
                onError);
        },
        goToStep: function (step) {
            if (step < 1 || step > 4) {
                return
            }
            this.hideAlert()
            this.currentStep = step
            return false
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        }
    }
}
</script>
